module.exports = __webpack_public_path__ + "static/media/pencil-plus.40f36610.svg";